import type { ColorScheme } from '@pesto/utils/src/style/colorSchemeHelper';

export enum ColorSchemeValue {
  HOMELIGHT = 'homeLight',
}

export const colorSchemes = {
  default: {
    '--primary': '240, 5.9%, 10%',
    '--accent': '240, 4.8%, 95.9%',
    '--accent-foreground': '240, 5.9%, 10%',
  },
  homeLight: {
    '--primary': '200 80% 50%',
    '--accent': '180 70% 60%',
  },
  pink: {
    '--primary': '330 80% 50%',
    '--accent': '310 70% 60%',
  },
  green: {
    '--primary': '150 80% 50%',
    '--accent': '130 70% 60%',
  },
  orange: {
    '--primary': '30 80% 50%',
    '--accent': '20 70% 60%',
  },
} satisfies Record<string, ColorScheme>;
